import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  ma_ngv: z.string().optional(),
  ma_gd: z.string().optional(),
  dien_giai: z.string().optional(),
  status: z.string().optional(),
  user_id0: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;
export const initialSearchValues: SearchFormValues = {
  so_ct1: '',
  so_ct2: '',
  ma_ngv: '',
  ma_gd: '',
  dien_giai: '',
  status: '',
  ngay_ct1: '',
  ngay_ct2: '',
  user_id0: ''
};

const nullableNumber = z.coerce.number().optional().nullable();
const nullableString = z.string().optional().nullable();
const nullableBoolean = z.boolean().optional().nullable();

export const FormSchema = z.object({
  dien_giai: nullableString,
  ghi_chu: nullableString,
  e_mail: nullableString,
  ty_gia: nullableNumber,
  ngay_ct: nullableString,
  ngay_lct: nullableString,
  ngay_hl: nullableString,
  so_hd: nullableString,
  status: nullableString,
  transfer_yn: nullableBoolean,
  ma_so_thue: nullableString,
  ten_kh_thue: nullableString,
  dia_chi: nullableString,
  ong_ba: nullableString,
  ma_nt: nullableString,
  tong_tien: nullableNumber,
  tong_chi_phi: nullableNumber,
  tong_thue: nullableNumber,
  tong_thanh_toan: nullableNumber,
  tong_so_luong: nullableNumber,
  t_cp_nt: nullableNumber,
  t_cp: nullableNumber,
  t_tien_nt: nullableNumber,
  t_tien: nullableNumber,
  t_thue_nt: nullableNumber,
  t_thue: nullableNumber,
  t_tt_nt: nullableNumber,
  t_tt: nullableNumber,
  dien_thoai: nullableString,
  fax: nullableString,
  ma_gd: nullableString,
  ly_do_huy: nullableString
});

export type FormValues = z.infer<typeof FormSchema>;

export const initialFormValues: FormValues = {
  dien_giai: '',
  ghi_chu: '',
  e_mail: '',
  ty_gia: 1,
  ngay_ct: new Date().toISOString(),
  ngay_lct: new Date().toISOString(),
  ngay_hl: '',
  so_hd: '',
  status: '0',
  transfer_yn: false,
  ma_so_thue: '',
  ten_kh_thue: '',
  dia_chi: '',
  ong_ba: '',
  ma_nt: '',
  tong_tien: 0,
  tong_chi_phi: 0,
  tong_thue: 0,
  tong_thanh_toan: 0,
  tong_so_luong: 0,
  t_cp_nt: 0,
  t_cp: 0,
  t_tien_nt: 0,
  t_tien: 0,
  t_thue_nt: 0,
  t_thue: 0,
  t_tt_nt: 0,
  t_tt: 0,
  dien_thoai: '',
  fax: '',
  ma_gd: '',
  ly_do_huy: ''
};
